import React, { useState, useMemo, useEffect, useCallback } from 'react'
import PropTypes from "prop-types";
import CountriesDropDown from '../shared/CountriesDropDown';
import StatesDropDown from "../shared/StatesDropDown";
import LanguagesDropDown from "../shared/LanguagesDropDown";
import NationalitiesDropDown from '../shared/NationalitiesDropDown';
import Panel from '../shared/Panel';
import { useTextResources } from '../../language';
import { Form } from 'semantic-ui-react';
import './style.css'
import { EntityType, MenuActions } from '../shared/constants';
import GuestSearchDropDown from '../shared/GuestSearchDropDown';
import CustomerDropDown from '../shared/CustomerDropDown';
import { onWarning } from '../shared/messages';

const FolioOwnerDetails = ({ currentNoRoomFolio, currentNoRoomOwner }) => {
  const text = useTextResources()
  const [newFolioOwner, setNewFolioOwner] = useState({})
  const [folioOwner, setFolioOwner] = useState({})
  const [country, setCountry] = useState("")
  const [state, setState] = useState("")
  const [states, setStates] = useState("")
  const [city, setCity] = useState("")
  const [street, setStreet] = useState("")

  useEffect(() => {
    if (currentNoRoomOwner) {
      setNewFolioOwner(currentNoRoomOwner)
      if(currentNoRoomOwner.Location){
      setCountry(currentNoRoomOwner.Location.Country.Id);
      setCity(currentNoRoomOwner.Location.City);
      setStreet(currentNoRoomOwner.Location.StreetAndHomeNumber);
    }
      // setFolioOwner({
      //   EntityTypeId: customer.CustomerTypeID === 1 ? EntityType.COMPANY : EntityType.AGENT,
      //   EntityId: customer.Id,
      //   Name: customer.Name
      // })
    } else {
      setNewFolioOwner({})
      setFolioOwner({})
    }
  }, [currentNoRoomOwner])

  useEffect(() => {
    if (window.optima && window.optima.commands) {
      if (window.optima.events) {
        window.optima.commands.unSubscribeAll(MenuActions.save)
        window.optima.commands.subscribe(MenuActions.save, save)
      }
    }
  }, [currentNoRoomFolio, newFolioOwner, folioOwner])

  const save = () => {
    window.postMessage({
      eventType: "NoRoomFolioSave",
      currentFolio: {
        ...currentNoRoomFolio,
        Owner: {
          ...folioOwner,
          EntityId: folioOwner.EntityId && folioOwner.EntityId.toString().startsWith("newguest-") ? 0 : folioOwner.EntityId
        }
      },
      currentOwner: {
        ...newFolioOwner,
        ID: newFolioOwner.Id && newFolioOwner.Id.toString().startsWith("newguest-") ? 0 : newFolioOwner.Id,
        Phone: newFolioOwner.Phone,
      }
    }, "*")
  }

  const updateNewOwner = (property, value) => {
    setNewFolioOwner(prev => {
      prev[property] = value
      return { ...prev }
    })
  }
  const CustomerSpec = React.useMemo(() => {
    return { GetOnlyCustomerArray: true, IsActive: true, IncludeCustomerTypeId: true, IncludeGuest: true }
  }, [])

  const customerSelected = customer => {
    if (customer) {
      setNewFolioOwner({
        ...customer.Guest,
        EntityTypeId: customer.CustomerTypeId === 1 ? EntityType.COMPANY : EntityType.AGENT,
        EntityId: customer.Id,
        VatNumber: customer.VatNumber
      })
      setFolioOwner({
        EntityTypeId: customer.CustomerTypeId === 1 ? EntityType.COMPANY : EntityType.AGENT,
        EntityId: customer.Id,
        Name: customer.Name
      })
    } else {
      setNewFolioOwner({})
      setFolioOwner({})
    }
  }

  const guestSelect = guest => {
    if (guest) {
      if (newFolioOwner && guest.EntityId && newFolioOwner.EntityId === guest.EntityId) {
        console.log('Guest already selected')
      } else {
        setNewFolioOwner(guest)
        setFolioOwner({
          EntityTypeId: EntityType.Guest,
          EntityId: guest.Id,
          Name: `${guest.FirstName} ${guest.LastName}`
        })
      }
    } else {
      setNewFolioOwner({})
      setFolioOwner({})
    }
  }

  const setNewGuest = val => {
    if (val && val.Id.toString().startsWith("newguest-")) {
      if (!val.FirstName || !val.LastName) {
        onWarning("Full name is required!")
        return;
      }
      guestSelect(val)
    } else {
      guestSelect(null)
    }
  }

  const isReadOnly = useCallback(() => {
    return currentNoRoomFolio &&
      currentNoRoomFolio.Owner &&
      currentNoRoomFolio.Owner.EntityId ? true : false
  }, [currentNoRoomFolio])

  const currentGuestId = useCallback(() => {
    if (newFolioOwner &&
      newFolioOwner.EntityTypeId === EntityType.Guest &&
      newFolioOwner.EntityId) {
      return newFolioOwner.EntityId
    } else return folioOwner &&
      folioOwner.EntityTypeId === EntityType.Guest &&
      folioOwner.EntityId ||
      null
  }, [newFolioOwner, folioOwner])

  const selectedGuest = useMemo(() => {
    return newFolioOwner &&
      newFolioOwner.EntityTypeId === EntityType.Guest &&
      newFolioOwner.EntityId ? {
      ...newFolioOwner,
      Id: newFolioOwner.EntityId
    } : null
  }, [newFolioOwner])

  const selectedCustomer = useMemo(() => {
    return newFolioOwner &&
      newFolioOwner.EntityTypeId !== EntityType.Guest &&
      newFolioOwner.EntityId || null
  }, [newFolioOwner])

  return <div className="FolioOwnerDetails">
    <Panel header={text("FolioOwner")} attached={true}>
      <Form>
        <Form.Field control={GuestSearchDropDown} clearable
          placeholder={text('SearchByNameEmailPhoneId')}
          disabled={isReadOnly()}
          label={text("Guest")}
          onAddGuest={setNewGuest}
          guest={selectedGuest}
          value={currentGuestId()}
          onChangeItem={guestSelect}
        />
        <Form.Field control={CustomerDropDown} clearable
          spec={CustomerSpec}
          value={selectedCustomer}
          label={text("Customer")}         
          disabled={isReadOnly()}
          placeholder="Select customer"
          onChangeItem={customerSelected}
        />
        <Form.Input
          name='Email'
          label='Email'
          placeholder='Email'
          type="email"
          value={(newFolioOwner && newFolioOwner.Email) || ""}
          onChange={(e, { value }) => updateNewOwner("Email", value)}
          disabled={isReadOnly()}
        />
        <Form.Input
          name='Phone'
          label="Phone"
          placeholder='Mobile'
          value={(newFolioOwner && newFolioOwner.Phone) || ""}
          onChange={(e, { value }) => updateNewOwner("Phone", value)}
          disabled={isReadOnly()}
        />
        <Form.Group widths="2">
          <Form.Field
            control={NationalitiesDropDown}
            label={text("Nationality")}
            value={newFolioOwner && newFolioOwner.NationalityID || null}
            onChange={value => updateNewOwner("NationalityID", value)}
            disabled={isReadOnly()}
          />
          <Form.Field
            value={newFolioOwner && newFolioOwner.LanguageID || null}
            control={LanguagesDropDown}
            onChange={value => updateNewOwner("LanguageID", value)}
            label="Language"
            disabled={isReadOnly()}
          />
        </Form.Group>
        <Form.Group widths="2">
          <Form.Field
            label={text("Country")}
            control={CountriesDropDown}
            value={country}
            spec={useMemo(() => {
              return {
                IncludeStates: true
              }
            }, [])}
            onChangeItem={item => {
              setCountry(item.Id)
              setStates(item.States)
              updateNewOwner("Country", item)
            }}
            disabled={isReadOnly()}
          />
          <Form.Field
            label={text("State")}
            value={state || null}
            data={states}
            control={StatesDropDown}
            onChange={setState}
            disabled={states.length === 0 || isReadOnly()}
          />
        </Form.Group>
        <Form.Group widths="2">
          <Form.Input
            name='City'
            label='City'
            value={city || newFolioOwner && newFolioOwner.City || null}
            onChange={(e, { value }) => updateNewOwner("City", value)}
            disabled={isReadOnly()}
          />
          <Form.Input
            name='Street'
            label="Street"
            value={street || newFolioOwner && newFolioOwner.StreetAndHomeNumber || null}
            onChange={(e, { value }) => updateNewOwner("StreetAndHomeNumber", value)}
            disabled={isReadOnly()}
          />
        </Form.Group>
      </Form>
    </Panel>
  </div>
}

FolioOwnerDetails.propTypes = {
  OwnerId: PropTypes.number,
  HotelID: PropTypes.number,
  OwnerTypeId: PropTypes.number,
  OnOwner: PropTypes.func,
  currentNoRoomFolio: PropTypes.object,
  currentNoRoomOwner: PropTypes.object
}
export default FolioOwnerDetails